module.exports = __webpack_public_path__ + "static/img/float.63bf13e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Home/float.png
// module id = /OAV
// module chunks = 2